import { DefaultValue, selectorFamily } from 'recoil';
import { createArrayAnyFieldByUniqueKeyHigherOrderSelectorFamily, createArrayAnyFieldHigherOrderSelectorFamily, createFieldSelectorFamily, } from '@zurich/common/recoil';
import { insuredObjectsByTypeSelectorFamily } from './root';
// This file contains selectors that will write to all insuredObject entries!
// write value in all vehicle insured object entries, show only one on get by type
export const anyInsuredObjectByTypeSelectorFamily = selectorFamily({
    key: '@zurich/contract/insuredObjectByType/any',
    get: (params) => ({ get }) => {
        const arr = get(insuredObjectsByTypeSelectorFamily(params));
        return Array.isArray(arr) ? (arr[0] ?? {}) : {};
    },
    set: (params) => ({ set }, value) => {
        // set in all array elements
        set(insuredObjectsByTypeSelectorFamily(params), (prevItems) => value instanceof DefaultValue
            ? []
            : prevItems?.length === 0
                ? [value]
                : prevItems.map(() => value));
        return;
    },
});
// FIXME: These complex functions need to be refactored
export const anyInsuredObjectByTypeInsuranceSegmentsSelectorFamily = createArrayAnyFieldHigherOrderSelectorFamily(anyInsuredObjectByTypeSelectorFamily, insuredObjectsByTypeSelectorFamily, 'insuranceSegments', {
    defaultValue: [],
});
export const anyInsuredObjectByTypeInsuranceSegmentBySegmentKeySelectorFamily = createArrayAnyFieldByUniqueKeyHigherOrderSelectorFamily(anyInsuredObjectByTypeSelectorFamily, insuredObjectsByTypeSelectorFamily, 'insuranceSegments', 'segmentKey', {
    defaultValue: {},
});
export const anyInsuredObjectByTypeInsuranceSegmentHelper = createFieldSelectorFamily(anyInsuredObjectByTypeInsuranceSegmentBySegmentKeySelectorFamily);
export const anyInsuredObjectByTypeInsuranceSegmentSelectedSelectorFamily = anyInsuredObjectByTypeInsuranceSegmentHelper('selected', {
    defaultValue: 'false',
});
